var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17162_78966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8541 26.8561C50.6021 27.1081 50.2637 27.2521 49.9109 27.2521H16.4669C15.2861 27.2521 14.6885 25.8121 15.5093 24.9553L20.9957 19.2745C21.2477 19.0153 21.5933 18.8641 21.9533 18.8641H55.5197C56.7077 18.8641 57.3053 20.3185 56.4629 21.1753L50.8541 26.8561ZM50.8541 52.2433C50.6021 52.4881 50.2637 52.6321 49.9109 52.6321H16.4669C15.2861 52.6321 14.6885 51.2281 15.5093 50.3929L20.9957 44.8489C21.2477 44.5969 21.5933 44.4529 21.9533 44.4529H55.5197C56.7077 44.4529 57.3053 45.8713 56.4629 46.7065L50.8541 52.2433ZM49.9109 31.6585C50.2637 31.6585 50.6021 31.7953 50.8541 32.0473L56.4629 37.5913C57.3053 38.4193 56.7077 39.8449 55.5197 39.8449H21.9533C21.5933 39.8449 21.2477 39.7009 20.9957 39.4489L15.5093 33.9049C14.6813 33.0697 15.2789 31.6657 16.4669 31.6657L49.9109 31.6585Z",
    fill: "#00FFAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 0C55.8792 0 72 16.1208 72 36C72 55.8792 55.8792 72 36 72C16.1208 72 0 55.8792 0 36C0 16.1208 16.1208 0 36 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6458 32.5653H49.9602C50.3778 32.5653 50.7738 32.7309 51.0618 33.0261L56.3322 38.3325C57.3042 39.3117 56.613 40.9821 55.2306 40.9821H21.9162C21.4986 40.9821 21.1026 40.8165 20.8146 40.5213L15.5442 35.2149C14.565 34.2357 15.2634 32.5653 16.6458 32.5653ZM15.5442 25.5309L20.8146 20.2245C21.1098 19.9293 21.5058 19.7637 21.9162 19.7637H55.2234C56.6058 19.7637 57.3042 21.4341 56.325 22.4133L51.0618 27.7197C50.7666 28.0149 50.3706 28.1805 49.9602 28.1805H16.6458C15.2634 28.1805 14.565 26.5101 15.5442 25.5309ZM56.325 48.0165L51.0546 53.3229C50.7594 53.6181 50.3634 53.7837 49.953 53.7837H16.6458C15.2634 53.7837 14.565 52.1133 15.5442 51.1341L20.8146 45.8277C21.1098 45.5325 21.5058 45.3669 21.9162 45.3669H55.2234C56.6058 45.3669 57.3042 47.0373 56.325 48.0165Z",
    fill: "url(#paint0_linear_17162_78966)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17162_78966",
    x1: 17.4608,
    y1: 55.2475,
    x2: 54.4083,
    y2: 18.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB4EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F4B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17162_78966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.f73d1a261b0a7eaeadb60d11617552fd.svg";
export { ForwardRef as ReactComponent };